import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconPrev = function IconPrev(_ref) {
  var className = _ref.className;
  return _jsx("span", Object.assign({
    className: "inline-block ".concat(className, " flex items-center justify-center bg-black opacity-70 rounded-full")
  }, {
    children: _jsxs("svg", Object.assign({
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      fill: 'none',
      version: '1.1',
      width: '36',
      height: '36',
      viewBox: '0 0 36 36'
    }, {
      children: [_jsx("defs", {
        children: _jsx("clipPath", Object.assign({
          id: 'master_svg0_6183_35645'
        }, {
          children: _jsx("rect", {
            x: '0',
            y: '36',
            width: '36',
            height: '36',
            rx: '0'
          })
        }))
      }), _jsxs("g", Object.assign({
        transform: 'matrix(0,-1,1,0,-36,36)',
        "clip-path": 'url(#master_svg0_6183_35645)'
      }, {
        children: [_jsx("g", {
          children: _jsx("rect", {
            x: '0',
            y: '36',
            width: '36',
            height: '36',
            rx: '0',
            fill: '#FFFFFF',
            "fill-opacity": '0.009999999776482582'
          })
        }), _jsx("g", {
          children: _jsx("path", {
            d: 'M26.95431689453125,59.295500000000004L18.74981689453125,51.09099L10.54531689453125,59.295500000000004C10.33433689453125,59.5065,10.04818689453125,59.625,9.74981689453125,59.625C9.12849689453125,59.625,8.62481689453125,59.1213,8.62481689453125,58.5C8.62481689453125,58.20163,8.74334289453125,57.91548,8.95432189453125,57.70451L17.95432689453125,48.704505C18.165296894531252,48.493526,18.45144689453125,48.3749999329448,18.74981689453125,48.375C19.04821689453125,48.375,19.33431689453125,48.493526,19.54531689453125,48.704505L28.54531689453125,57.70451C28.75631689453125,57.91548,28.87481689453125,58.20163,28.87481689453125,58.5C28.87481689453125,59.1213,28.37111689453125,59.625,27.74981689453125,59.625C27.45141689453125,59.625,27.16531689453125,59.5065,26.95431689453125,59.295500000000004Z',
            "fill-rule": 'evenodd',
            fill: '#FFFFFF',
            "fill-opacity": '1'
          })
        })]
      }))]
    }))
  }));
};
export default IconPrev;